import { defineStore } from "pinia";
import api from "@/services/api";

export const useBuildStore = defineStore("build", {
  state: () => ({
    error: "" as any,
    data: new Map<string, string>(),
    loaded: false,
  }),
  actions: {
    async fetchAll(force = false) {
      if (!force && this.loaded) return;
      this.error = "";
      const config = force
        ? {
            headers: {
              // Request-side hints; real cache-bust comes from the query param below
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
            },
            params: { _cb: Date.now() },
          }
        : undefined;
      await api
        .get<Record<string, string>>(`.build/info`, config as any)
        .then((response) => {
          this.data.clear();
          Object.entries(response.data).forEach(([key, value]) => {
            this.data.set(key, value as string);
          });
          this.loaded = true;
        })
        .catch((error) => (this.error = error));
      
    },
  },
  getters: {
    getByKey:
      (state) =>
        (key: string): string => {
          return <string>state.data.get(key) || "";
        },
  },
});
